import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useContext } from 'react'
import styles from '../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';
import campaignStyles from './../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignAnalysisStyle.module.scss'
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import globalStyles from '../../../assets/styles/global.module.scss';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { formatDateAccordingToTimezoneUsingMoment } from '../../../utils/constants';
import { campaignAnalyticsStatus, contactCampaignTrackingStatus } from '../../../models/axiosModel';

interface statusTrackInterface {
    flagAnalyticsStatus: boolean
}

const CampaignContactStatusTrack = (props: statusTrackInterface) => {
    const { flagAnalyticsStatus } = props;
    const { currentContactStatus, messageTemplateDetail } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload
    const { userDetail } = useContext(UserContext) as UserContextPayload

    const innerHeight = window.innerHeight - 200;

    const buttonValue = (status: campaignAnalyticsStatus, flagURL?: boolean) => {
        if (messageTemplateDetail && messageTemplateDetail?.whatsapp_template_data) {
            let buttons = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button;
            let existingButton = buttons.find((button) => button.whatsapp_template_button_id == status.whatsapp_template_button_id) 
            if (existingButton) {
                let buttonData = existingButton?.whatsapp_template_button_data?.[0]
                let subTypeFieldData = buttonData?.whatsapp_template_button_sub_type_field_data
                let existingSubType = subTypeFieldData?.find((field) => field.whatsapp_template_button_sub_type_field_id?.toString() == "3")
                let existingBtnURL = subTypeFieldData?.find((field) => field.whatsapp_template_button_sub_type_field_id?.toString() == "5")
                if (existingSubType && !flagURL) {
                    return existingSubType?.whatsapp_template_button_sub_type_field_value?.toString()
                }
                if (flagURL) {
                    return existingBtnURL?.whatsapp_template_button_sub_type_field_value?.toString()
                }
                return "-"
            }
            return "-"
        }
        return "-"
    }

    const buttonValueReply = (status: campaignAnalyticsStatus) => {
        if (messageTemplateDetail && messageTemplateDetail?.whatsapp_template_data) {
            let buttons = messageTemplateDetail?.whatsapp_template_data?.[0]?.whatsapp_template_button;
            let existingButton = buttons.find((button) => button.whatsapp_template_button_id == status.whatsapp_template_button_id) 
            if (existingButton) {
                let buttonData = existingButton?.whatsapp_template_button_data?.[0]
                let subTypeFieldData = buttonData?.whatsapp_template_button_sub_type_field_data
                let existingSubType = subTypeFieldData?.find((field) => field.whatsapp_template_button_sub_type_field_id?.toString() == "9")
                if (existingSubType) {
                    return existingSubType?.whatsapp_template_button_sub_type_field_value?.toString()
                }
                return "-"
            }
            return "-"
        }
        return "-"
    }

    const finalAnalyzedContacts = () => {
        const currentClickedContacts = currentContactStatus?.campaign_analytics_status?.filter((status) => status.campaign_execution_status_name?.toLowerCase() == "clicked")

        let finalContacts: campaignAnalyticsStatus[] = [];
        if (currentClickedContacts && currentClickedContacts?.length > 0) {
            for (let i=0; i<currentClickedContacts.length; i++) {
                let data = currentClickedContacts[i];
                if (finalContacts && finalContacts?.length > 0) {
                    let findData = finalContacts.find((contacts) => contacts.whatsapp_template_button_id == data.whatsapp_template_button_id)
                    if (findData) {
                        findData.count += 1;
                        if (new Date(data.timestamp) > new Date(findData.timestamp)) {
                            findData.timestamp = data.timestamp;
                        }
                    }
                    else {
                        let updatedData = {
                            ...data,
                            count: 1
                        }
                        finalContacts?.push(updatedData)
                    }
                }
                else {
                    let updatedData = {
                        ...data,
                        count: 1
                    }
                    finalContacts?.push(updatedData)
                }
            }
        }
        return finalContacts
    }

    const getSortedExecutionStatusData = () => {
        if(currentContactStatus){
            return currentContactStatus?.campaign_execution_tracking_data?.sort((a: contactCampaignTrackingStatus, b: contactCampaignTrackingStatus) => new Date(a.webhook_timestamp).getTime() - new Date(b.webhook_timestamp).getTime())
                ?.sort((a, b) => a.whatsapp_webhook_log_id - b.whatsapp_webhook_log_id) ?? [];
        }
        return [];
    }

    const getSortedClickedAnalyticsData = () => {
        return finalAnalyzedContacts()?.sort((a: campaignAnalyticsStatus, b: campaignAnalyticsStatus) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()) ?? [];
    }

    const getSortedRepliedAnalyticsData = () => {
        if (currentContactStatus) {
            return currentContactStatus?.campaign_analytics_status
                ?.filter((status) => status?.campaign_execution_status_name?.toLowerCase() == "replied")
                ?.sort((a: campaignAnalyticsStatus, b: campaignAnalyticsStatus) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()) ?? [];
        }
        return [];
    }

    const tableCellClass = dashboardStyles.tableBodySubHeadingFontStyle

    return (
        <Grid container sx={{zIndex: "10 !important"}} className={globalStyles.maxWidthFull}>
            <Grid item xs={12} className={`${globalStyles.maxWidthFull} ${globalStyles.minWidthZero}`}>
                <Grid container direction={"column"} gap={"20px"} className={campaignStyles.contactStatusPopupContent}>
                    <Grid item textAlign={"center"} className={globalStyles.fullwidth}>
                        <Typography className={styles.popupTitleStyle}>{flagAnalyticsStatus ? "Contact Analytics Status" : "Contact Execution Status"}</Typography>
                    </Grid>

                    <Grid item className={globalStyles.fullwidth}>
                        <Divider style={{ opacity: "0.3", color: "#9D9D9D", border: "0.2px solid #9D9D9D" }} />
                    </Grid>

                    <Grid item className={`${globalStyles.minWidthZero} ${globalStyles.fullwidth}`}>
                        <Grid container gap={"12px"} sx={{ maxHeight: `${innerHeight}px !important` }} className={`${globalStyles.overflowAuto} ${campaignStyles.contactStatusPopupBody}`}>
                            <Grid item xs={12} md={6} className={globalStyles.minWidthZero}>
                                <Grid container gap={1} flexWrap={"nowrap"} alignItems={"flex-start"}>
                                    <Grid item className={campaignStyles.contactStatusInfoLabel}>
                                        <span className={campaignStyles.statusKeyStyle}>Phone Number:</span>
                                    </Grid>
                                    <Grid item className={campaignStyles.contactStatusInfoValue}>
                                        <span className={campaignStyles.statusValueStyle}>{currentContactStatus?.contact_phone_number}</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={6} className={globalStyles.minWidthZero}>
                                <Grid container gap={1} flexWrap={"nowrap"} alignItems={"flex-start"}>
                                    <Grid item className={campaignStyles.contactStatusInfoLabel}>
                                        <span className={campaignStyles.statusKeyStyle}>Name: </span>
                                    </Grid>
                                    <Grid item className={campaignStyles.contactStatusInfoValue}>
                                        <span className={campaignStyles.statusValueStyle}>{currentContactStatus?.contact_name ? currentContactStatus?.contact_name : "-"}</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {!flagAnalyticsStatus &&
                                <Grid item xs={12} mt={"6px"} className={globalStyles.minWidthZero}>
                                    <TableContainer className={campaignStyles.contactStatusTableContainer}>
                                        <Table aria-label="simple table" stickyHeader className={campaignStyles.contactStatusTable}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle} sx={{ width: "22%" }}>Message Status</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle} sx={{ width: "28%" }}>Time</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle} sx={{ width: "50%" }}>Error</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {getSortedExecutionStatusData()?.length > 0 ? 
                                                    getSortedExecutionStatusData()?.map((status: contactCampaignTrackingStatus, ind: number) => 
                                                        <TableRow key={ind} className={dashboardStyles.cellRow}>
                                                            <TableCell className={tableCellClass} sx={{textTransform: "capitalize"}}>{status.message_status}</TableCell>
                                                            <TableCell className={tableCellClass}>{status.webhook_timestamp ? formatDateAccordingToTimezoneUsingMoment(status.webhook_timestamp, userDetail.timezone_hour, "campaign") : "-"}</TableCell>
                                                            <TableCell className={tableCellClass}>{status.error_obj ? status.error_obj : "-"}</TableCell>
                                                        </TableRow>
                                                    )
                                                    :
                                                    <TableRow className={dashboardStyles.cellRow}>
                                                        <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                            No Data Available
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            }
                            {flagAnalyticsStatus && currentContactStatus?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "clicked") &&
                                <Grid item xs={12} mt={"6px"} className={globalStyles.minWidthZero}>
                                    <TableContainer className={campaignStyles.contactStatusTableContainer}>
                                        <Table aria-label="simple table" stickyHeader className={campaignStyles.contactStatusTable}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Button Name</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Button URL</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Last Updated Time</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Status</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Count</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {getSortedClickedAnalyticsData()?.length > 0 ?
                                                    getSortedClickedAnalyticsData()?.map((status: campaignAnalyticsStatus, ind: number) =>
                                                        <TableRow key={ind} className={dashboardStyles.cellRow}>
                                                            <TableCell className={tableCellClass}>
                                                                {buttonValue(status)}
                                                            </TableCell>
                                                            <TableCell className={tableCellClass}>
                                                                {buttonValue(status, true)}
                                                            </TableCell>
                                                            <TableCell className={tableCellClass}>{status.timestamp ? formatDateAccordingToTimezoneUsingMoment(status.timestamp, userDetail.timezone_hour, "campaign") : "-"}</TableCell>
                                                            <TableCell className={tableCellClass}>{status.campaign_execution_status_name}</TableCell>
                                                            <TableCell className={tableCellClass}>{status.count}</TableCell>
                                                        </TableRow>
                                                    )
                                                    :
                                                    <TableRow className={dashboardStyles.cellRow}>
                                                        <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                            No Data Available
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            }
                            {flagAnalyticsStatus && currentContactStatus?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "replied") &&
                                <Grid item xs={12} mt={"6px"} className={globalStyles.minWidthZero}>
                                    <TableContainer className={campaignStyles.contactStatusTableContainer}>
                                        <Table aria-label="simple table" stickyHeader className={campaignStyles.contactStatusTable}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Button Name</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Last Updated Time</TableCell>
                                                    <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Status</TableCell>
                                                    {/* <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Count</TableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {getSortedRepliedAnalyticsData()?.length > 0 ?
                                                    getSortedRepliedAnalyticsData()?.map((status: campaignAnalyticsStatus, ind: number) =>
                                                        <TableRow key={ind} className={dashboardStyles.cellRow}>
                                                            <TableCell className={tableCellClass}>
                                                                {buttonValueReply(status)}
                                                            </TableCell>
                                                            <TableCell className={tableCellClass}>{status.timestamp ? formatDateAccordingToTimezoneUsingMoment(status.timestamp, userDetail.timezone_hour, "campaign") : "-"}</TableCell>
                                                            <TableCell className={tableCellClass}>{status.campaign_execution_status_name}</TableCell>
                                                            {/* <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{status.count}</TableCell> */}
                                                        </TableRow>
                                                    )
                                                    :
                                                    <TableRow className={dashboardStyles.cellRow}>
                                                        <TableCell colSpan={12} className={globalStyles.textCenter}>
                                                            No Data Available
                                                        </TableCell>
                                                    </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CampaignContactStatusTrack
